
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import { UserModule } from '../../store/modules/user'
  @Component
export default class Message extends Vue {
    @Prop() messagePop: boolean
    @Prop() title: string
    @Prop() messageTemplate: any
    @Prop() messageItemVal: any


    student_type_list: any = []
    frequency_options: any = ['1', '2', '3', '4', '5', '6', '7']
    checkedFrequency: any = []   // 发送频率承载
    isIndeterminate: boolean = true
    frequency_all: boolean = false
    sendTimeProps: any = { multiple: true }
    p_hight: any = window.innerHeight - 80 + 'px'
    sendTimelist: any = []
    template_show_id: string = ''
    messageDetails: any = {
      name: '',
      template_id: '',
      student_type: '',
      frequency: '', 
      execute_time: '', // 发送时间
      start_time: '', 
      end_time: '',
      is_enabled: 1
    }
    org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
    studentList: any = []
    student_id: any = []
    messagePopTemplate: any = []
    time = [new Date(<any>new Date() - 1000 * 60 * 60 * 24 * 30), new Date()]
    campus: any = []
    sendTimeoptions: any = [
      {
        value: 'shangwu',
        label: '上午',
        children: [
          {
            value: '06:30',
            label: '06:30'
          },
          {
            value: '07:00',
            label: '07:00'
          },
          {
            value: '07:30',
            label: '07:30'
          },
          {
            value: '08:00',
            label: '08:00'
          },
          {
            value: '08:30',
            label: '08:30'
          },
          {
            value: '09:00',
            label: '09:00'
          },
          {
            value: '09:30',
            label: '09:30'
          },
          {
            value: '10:00',
            label: '10:00'
          },
          {
            value: '10:30',
            label: '10:30'
          },
          {
            value: '11:00',
            label: '11:00'
          },
          {
            value: '11:30',
            label: '11:30'
          },
          {
            value: '12:00',
            label: '12:00'
          }
        ]
      },
      {
        value: 'xiawu',
        label: '下午',
        children: [
          {
            value: '12:30',
            label: '12:30'
          },
          {
            value: '13:00',
            label: '13:00'
          },
          {
            value: '13:30',
            label: '13:30'
          },
          {
            value: '14:00',
            label: '14:00'
          },
          {
            value: '14:30',
            label: '14:30'
          },
          {
            value: '15:00',
            label: '15:00'
          },
          {
            value: '15:30',
            label: '15:30'
          },
          {
            value: '16:00',
            label: '16:00'
          },
          {
            value: '16:30',
            label: '16:30'
          },
          {
            value: '17:00',
            label: '17:00'
          },
          {
            value: '17:30',
            label: '17:30'
          },
          {
            value: '18:00',
            label: '18:00'
          }
        ]
      },
      {
        value: 'wanshang',
        label: '晚上',
        children: [
          {
            value: '18:30',
            label: '18:30'
          },
          {
            value: '19:00',
            label: '19:00'
          },
          {
            value: '19:30',
            label: '19:30'
          },
          {
            value: '20:00',
            label: '20:00'
          },
          {
            value: '20:30',
            label: '20:30'
          },
          {
            value: '21:00',
            label: '21:00'
          },
          {
            value: '21:30',
            label: '21:30'
          },
          {
            value: '22:00',
            label: '22:00'
          },
          {
            value: '22:30',
            label: '22:30'
          },
          {
            value: '23:00',
            label: '23:00'
          },
          {
            value: '23:30',
            label: '23:30'
          }
        ]
      }
      
    ]
    campusList: any = []
    agesList: any = [
      {
        id: '1',
        value: '成人'
      },
      {
        id: '2',
        value: '儿童'
      },
      {
        id: '3',
        value: '学生'
      }
    ]
    ages: any = []
    instrumentList: any = []
    instrument: any = []
    courseTypeList: any = []
    courseType: any = []

    @Watch('messagePop')
    getMessagePop(newVal, oldVal) {
      if(newVal) {
        this.getHeight()
        this.getStudent()
        this.getCampus()
        this.getInstrument()
        this.getCourseType()

        if(this.title === 'edit') {
          this.messageDetails = {
            name: this.messageItemVal.name,
            template_id: this.messageItemVal.template_id,
            is_enabled: this.messageItemVal.is_enabled
          }
          // 回显Cascader 级联选择器  this.sendTimelist = [['shangwu','06:30'],['shangwu','07:00']]
          if(this.messageItemVal.execute_time) {
            let arr = this.messageItemVal.execute_time.split(',') // 发送时间
            var sendTimeArr = [];
            for (var index = 0; index < arr.length; index += 2) {
              sendTimeArr.push([arr[index], arr[index + 1]]);
            }
            this.sendTimelist = sendTimeArr
          } else {
            this.sendTimelist = []
          }
          let time_left: any = this.messageItemVal.start_time * 1000
          let time_right: any = this.messageItemVal.end_time * 1000
          this.messageDetails.start_time = this.messageItemVal.start_time
          this.messageDetails.end_time = this.messageItemVal.end_time
          this.time = [ time_left, time_right ]
          let student_type = JSON.parse(this.messageItemVal.student_type)
          this.ages = student_type.ages
          this.student_type_list = student_type.types
          this.student_id = student_type.student_id
          this.campus = student_type.campus_id
          this.instrument = student_type.instrument_type_id
          this.courseType = student_type.base_course_id
          if (this.messageItemVal.frequency) {
            this.checkedFrequency = this.messageItemVal.frequency.split(',')
          } else {
            this.checkedFrequency = []
          }
        } else {
          this.refreshMessage()
        }
        this.messagePopTemplate = this.messageTemplate
        for(var i = 0; i < this.messagePopTemplate.length; i++) {
          this.messagePopTemplate[i]['name_str'] = `${this.messagePopTemplate[i].content}(${this.messagePopTemplate[i].name})`
        }
      }
    }

    mounted() {
      
    }
    changePopMessageTemplate(val) {
      this.messageDetails.template_id = val
    }
    changeFrequencyAll(val) {
      this.checkedFrequency = val ? this.frequency_options : [];
      this.isIndeterminate = false
    }
    handleCheckedFrequencyChange(value) {
      let checkedCount = value.length;
      this.frequency_all = checkedCount === this.frequency_options.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.frequency_options.length;
    }

    async getStudent() {
      const res: any = await UserModule.student({ org_id: this.org_id, name: '' })
      if (res.code === 200) {
        this.studentList = res.data.list
      }
    }
    async getCampus() {
      const res: any = await UserModule.getSchool()
      if(res.code === 200) {
        this.campusList = res.data.list
      }
    }
    async getInstrument () {
      const res: any = await UserModule.getInstrument({ org_id: this.org_id })
      if(res.code === 200) {
        this.instrumentList = res.data.list
      }
    }

    async getCourseType() {  // 获取课程种类
      const res: any = await UserModule.courseType()
      if(res.code === 200) {
        this.courseTypeList = res.data.list
      }
    }

    refreshMessage() {
      this.messageDetails = {
        name: '',
        template_id: '',
        student_type: '',
        frequency: '', 
        execute_time: '', // 发送时间
        start_time: '', 
        end_time: '',
        is_enabled: 1
      }
      this.checkedFrequency = []
      this.student_type_list = []
      this.ages = []
      this.student_id = []
      this.campus= []
      this.instrument = []
      this.courseType = []
      this.sendTimelist = []
    }
     
    close(){
      this.$emit('close-message', {type: false})
      this.refreshMessage()
    }
    submit() {
      let data = {
        name: this.messageDetails.name,
        template_id: this.messageDetails.template_id,
        is_enabled: this.messageDetails.is_enabled,
        frequency: this.checkedFrequency.join(','),
        student_type: JSON.stringify({ types: this.student_type_list, ages: this.ages, student_id: this.student_id, campus_id: this.campus, instrument_type_id: this.instrument, base_course_id: this.courseType}),
        execute_time: this.sendTimelist.join(','),
        start_time: this.messageDetails.start_time,
        end_time: this.messageDetails.end_time,
      }
      if (this.title === 'edit') {
        data['id'] = this.messageItemVal.id
        this.editMessage(data)
      } else {
        this.createMessage(data)
      } 
    }
    async createMessage(data) {
      const res: any = await CourseModule.messageTaskPost(data)
      if(res.code === 200) {
        this.$emit('close-message', {type: true})
      }
    }
    async editMessage(data) {
      const res: any = await CourseModule.messageTaskPut(data)
      if(res.code === 200) {
        this.$emit('close-message', {type: true})
      }
    }

    changeStudentType(val) {
      this.student_type_list = val
    }
    getHeight() {
      window.onresize = () => {
        this.p_hight = window.innerHeight - 80 + 'px'
      }
    }
    changeTime(val){
      const end = new Date(Date.parse(<any>new Date(val[1])) + 24 * 60 * 60 * 1000 - 1000)
      this.time = [val[0], end]
      if (this.time) {
        this.messageDetails.start_time = (Date.parse(<any>this.time[0]) / 1000).toString()
        this.messageDetails.end_time = (Date.parse(<any>this.time[1]) / 1000).toString()
      } else {
        this.messageDetails.start_time = ''
        this.messageDetails.end_time = ''
      }
    }
    sortChange(val){
      
    }
  
}
